import { Type, Field } from 'serialize-ts';

import { BaseHttpError } from '~shared/modules/error-handler/models/base-http-error.model';

import { InvalidParams } from './invalid-params.model';
import { InvalidParamsSerializer } from '../classes/invalid-params-serializer.class';

export class ImsHttpError extends BaseHttpError {
  @Field()
  status: number;

  @Field()
  title: string;

  @Field()
  detail: string;

  @Field()
  @Type(new InvalidParamsSerializer())
  invalidParams: InvalidParams = {};
}
